const IMAGES = {
  menu: require("./icons/menu.png").default,
  close: require("./icons/close.png").default,
  light: require("./icons/light.png").default,
  dark: require("./icons/dark.png").default,

  html: require("./skills/html.png").default,
  css: require("./skills/css.png").default,
  tailwind: require("./skills/tailwind.jpg").default,
  react: require("./skills/react.png").default,
  js: require("./skills/js.png").default,
  nodejs: require("./skills/nodejs.png").default,
  firebase: require("./skills/firebase.png").default,
  git: require("./skills/git.png").default,

  open: require("./icons/open.png").default,
  repo: require("./icons/repo.png").default,

  portfolio: {
    portfolio_1: require("./projects/portfolio/portfolio_1.png").default,
    portfolio_2: require("./projects/portfolio/portfolio_2.png").default,
    portfolio_3: require("./projects/portfolio/portfolio_3.png").default,
    portfolio_4: require("./projects/portfolio/portfolio_4.png").default,
    portfolio_5: require("./projects/portfolio/portfolio_5.png").default,
  },

  the_venue: {
    the_venue_1: require("./projects/the_venue/the_venue_1.png").default,
    the_venue_2: require("./projects/the_venue/the_venue_2.png").default,
    the_venue_3: require("./projects/the_venue/the_venue_3.png").default,
    the_venue_4: require("./projects/the_venue/the_venue_4.png").default,
    the_venue_5: require("./projects/the_venue/the_venue_5.png").default,
    the_venue_6: require("./projects/the_venue/the_venue_6.png").default,
  },

  instagram: {
    instagram_1: require("./projects/instagram/instagram_1.png").default,
    instagram_2: require("./projects/instagram/instagram_2.png").default,
    instagram_3: require("./projects/instagram/instagram_3.png").default,
    instagram_4: require("./projects/instagram/instagram_4.png").default,
    instagram_5: require("./projects/instagram/instagram_5.png").default,
  },

  ipl: {
    ipl_1: require("./projects/ipl/ipl_1.png").default,
    ipl_2: require("./projects/ipl/ipl_2.png").default,
    ipl_3: require("./projects/ipl/ipl_3.png").default,
    ipl_4: require("./projects/ipl/ipl_4.png").default,
    ipl_5: require("./projects/ipl/ipl_5.png").default,
    ipl_6: require("./projects/ipl/ipl_6.png").default,
  },

  linkedin: require("./icons/linkedin.png").default,
  mail: require("./icons/mail.png").default,
  download: require("./icons/download.png").default,
};

export default IMAGES;
